export default {
  common: {
    noData: "No Data Available",
  },
  nav: {
    home: "Home",
    about: "About Cosys",
    solution: "Solution & Core Technology",
    news: "News Center",
    contact: "Contact Us",
    search: "Search",
  },
  news: {
    title: "News Center",
    subtitle: "NEWS CENTER",
    more: "Explore More",
    readMore: "Read More",
    list: [
      {
        title: "Beibu Gulf Port's 'Ace Equipment' Shows Impressive Performance",
        desc: "Recently, good news came from the Fangchenggang Wharf of Beibu Gulf Port. The automated bulk cargo unloader independently developed by Kexin Technology has set a new record in the bauxite unloading operation. The single-machine efficiency has reached 1,626 tons per hour, which is 10% higher than the efficiency of traditional manual operation. It has become the first automated bulk cargo unloader of the same type in China to surpass the efficiency of manual operation.",
        date: "2025-04-18",
        url: "/news/57",
      },
      {
        title:
          "Smart Coal Yard's 'Skill Tree' is Fully Unlocked! Let's Take a Look!",
        desc: "You might think coal yards are like this: people needed for material retrieval, people needed for stacking, people needed for opening piles, people needed for inspection. But today's smart coal yards have achieved full automation. The system, through installing positioning sensors, radar level meters, radar collision prevention sensors and other equipment on stacker-reclaimers, combined with unmanned system PLC and other electrical control systems, can maintain high alertness 24/7, continuously monitoring the real-time dynamics of the yard equipment regardless of day or night.",
        date: "2025-01-15",
        url: "/news/55",
      },
      {
        title:
          "Scientific Achievement | Zhejiang Company's Ninghai Power Plant Smart Coal Yard Project Wins Energy Conservation and Emission Reduction Technology Innovation Award",
        desc: "On November 22, Zhejiang Company's Ninghai Power Plant's 'Research and Application of Intelligent Control System for No.3 and No.4 Circular Coal Yards' project won the second prize for energy conservation and emission reduction technology innovation awarded by the China Energy Conservation Association. This achievement, focusing on intelligent power generation enterprise construction under the new power situation, innovatively proposed implementing a highly standardized, comprehensive, and strongly open intelligent control system from the perspectives of technological innovation, energy conservation, and human health, achieving 3D digital management of coal yard piles to reach the goal of energy conservation and efficiency improvement.",
        date: "2024-11-27",
        url: "/news/56",
      },
      {
        title: "How Can Power Plants Reduce Carbon Emissions?",
        desc: "China will achieve carbon neutrality before 2060. As one of China's largest power generation enterprises, Huaneng Group is one of the key players paving the way for this goal. Smart and green initiatives are driving power plants like Huaneng to transform from traditional smokestack enterprises.",
        date: "2021-11-25",
        url: "/news/53",
      },
    ],
    article56: {
      title:
        "Technological Achievement | Ninghai Power Plant's Intelligent Coal Yard Project Wins Energy Conservation Innovation Award",
      date: "2024-11-27",
      preview:
        "On November 22, Zhejiang Company's Ninghai Power Plant's \"Research and Application of Intelligent Control System for No. 3 and 4 Circular Coal Yards\" project was awarded the second prize for Energy Conservation and Emission Reduction Technology Innovation by the China Energy Conservation Association. This achievement focuses on building intelligent power generation enterprises under the new power industry situation, innovatively proposing a highly standardized, comprehensive, and open intelligent control system from multiple perspectives including technological innovation, energy efficiency, and human health, achieving 3D digital management of coal piles for energy conservation and efficiency improvement.",
      readMore: "Read Full Article on WeChat",
      content: {
        title:
          "Technological Achievement | Ninghai Power Plant's Intelligent Coal Yard Project Wins Energy Conservation Innovation Award",
        date: "2024-11-27",
        text: [
          "On November 22, Zhejiang Company's Ninghai Power Plant's \"Research and Application of Intelligent Control System for No. 3 and 4 Circular Coal Yards\" project was awarded the second prize for Energy Conservation and Emission Reduction Technology Innovation by the China Energy Conservation Association. This achievement focuses on building intelligent power generation enterprises under the new power industry situation, innovatively proposing a highly standardized, comprehensive, and open intelligent control system from multiple perspectives including technological innovation, energy efficiency, and human health, achieving 3D digital management of coal piles for energy conservation and efficiency improvement.",
          "In the research of this achievement, technical personnel, combining equipment operation conditions with operator experience, developed multiple innovations including one-click vehicle path optimization, one-click intelligent pile opening, constant-flow intelligent blending, and slip ring temperature monitoring. These innovations have enabled fully automated unmanned operation of the entire coal yard process, including automatic coal reclaiming, stacking, pile opening, rotation, and replenishment, as well as automatic coal inventory and precise coal blending. Since its implementation, the system has effectively enhanced the intelligent management level and production efficiency of the coal yard, achieving energy conservation and efficiency improvement goals. Under the guidance of the Group Company's '41663' overall work policy, while ensuring reliable energy supply, the plant has vigorously promoted digital and intelligent innovation development integrating 'thermal power +'. The successful implementation of this achievement has effectively realized cost reduction and efficiency improvement for power generation enterprises, contributing to energy conservation and carbon reduction, with broad prospects for promotion under the 'dual carbon' goals.",
        ],
        credits: {
          title: "Project Team",
          members: [
            "Project Manager: Zhang",
            "Technical Director: Li",
            "System Architect: Wang",
            "Field Implementation: Liu",
            "Technical Support: Chen",
          ],
        },
      },
    },
    article55: {
      title: "Smart Coal Yard: All Skills Unlocked! Take a Look!",
      date: "2025-07-24",
      preview:
        "You might think a coal yard needs people for material handling, stockpile rotation, pile opening, and inspection. But now, the smart coal yard has achieved full automation...",
      readMore: "Read More",
      content: {
        title: "Smart Coal Yard: All Skills Unlocked! Take a Look!",
        date: "2025-07-24",
        traditionalCoalYard: {
          title: "This is what you think a coal yard looks like",
          features: [
            "People needed for material handling",
            "People needed for stockpile rotation",
            "People needed for pile opening",
            "People needed for inspection",
          ],
        },
        smartPlatform: {
          intro: [
            "Come to Ninghai Power Plant of Zhejiang Company, State Energy Group",
            "See the intelligent control platform for circular coal yard",
            "All problems can be solved with just a few clicks",
            "Let's experience this amazing platform together!",
          ],
          description: [
            "The intelligent control platform for circular coal yard was",
            "independently developed by Deng Jianguo Innovation Studio at Ninghai Power Plant",
            "The platform displays in 3D form through the installation of",
            "laser scanners, high-precision pan-tilt devices, and CPU control units",
            "achieving real-time data collection, high-speed computing, data exchange and fusion",
            "15 skills and multiple 'hidden' functions solve circular coal yard production management and stacking operations",
            "controlling core business requirements",
            "simplifying production management model, achieving digital twin",
            "Come pick your favorite skill!",
          ],
        },
        skills: {
          skill1: {
            title: "Skill 1: 24/7 Smart Online Butler",
            description: [
              "Also known as the unmanned system. The system installs positioning sensors, radar level meters, and radar",
              "anti-collision sensors on stacker-reclaimers, working with PLC and other electrical control systems, operating",
              "vigorously 24/7, continuously monitoring coal yard equipment in real-time.",
            ],
          },
          skill2: {
            title: "Skill 2: Smart Navigation Parking Assistant",
            description: [
              "Also known as intelligent path-optimized vehicle movement. In the past, traditional vehicle movement was time-consuming and labor-intensive. Now, with just one click to issue a vehicle movement task",
              "command, the system automatically plans the optimal path, just like having GPS navigation!",
            ],
          },
          skill3: {
            title: "Skill 3: Unmanned Driving Superhero",
            description: [
              "Also known as one-click intelligent pile opening. Previously, pile opening was like driving on mountain roads, requiring careful operation. Now, the 'superhero'",
              "starts with one click, intelligently analyzes, and instantly flattens the pile surface, achieving precision and efficiency with zero risk and zero errors.",
            ],
          },
          skill4: {
            title: "Skill 4: Five-star Chef with Precise Blending",
            description: [
              "Also known as intelligent blending system. Previously, blending was done by feel. Now, with precise control of material flow rate, constant ratio is",
              "easily achieved! With PID calculation support, material blending is both scientific and efficient!",
            ],
          },
          skill5: {
            title: "Skill 5: Naked-eye 3D Movie",
            description: [
              "Also known as digital 3D coal yard. Previously, the system displayed stacker-reclaimers and coal piles in 2D, unable to show dynamic changes. Now, the entire",
              "coal yard's three-dimensional material morphology is displayed in 3D. The rotation and tilting of stacker-reclaimers",
              "are shown in real-time, just like watching a 3D movie!",
            ],
          },
          skill6: {
            title: "Skill 6: Coal Yard Scanning Wonder",
            description: [
              "Also known as one-click coal inventory system. Previously, it took 30 minutes per inventory with 1 laser scanner + manual operation. Now,",
              "coal inventory can be completed in just 3 minutes, with amazing efficiency! It can also update coal yard storage targets with one click, precisely calculate coal",
              "yard volume and weight, the speed and efficiency are incredible!",
            ],
          },
          skill7: {
            title: "Skill 7: 'Topographic Map' of the Coal Yard",
            description: [
              "Also known as coal yard 2D map. Previously, manually drawn coal yard maps had significant differences from reality. Now, the system can",
              "divide the coal yard into multiple zones, achieving zone-based coal type stacking. After each task, it can immediately perform dynamic inventory",
              "of the coal yard, instantly generating a 3D coal yard graphic. Volume, quality, and price analysis are all handled effortlessly!",
            ],
          },
          additionalSkills: [
            "Besides these skills",
            "there are also intelligent lighting, equipment temperature monitoring alarm system",
            "real-time equipment operation curves, lifecycle management and other skills",
          ],
        },
        achievements: {
          intro: [
            "Nowadays",
            "this 'skill tree' is not only full of technology",
            "but also rich in achievements",
            "After operation",
          ],
          results: [
            "Reduced standard coal loss by 1,060 tons/year",
            "Saved 370,000 kWh of electricity/year",
            "Reduced maintenance costs by 300,000 yuan/year",
            "Improved work efficiency by 33%",
          ],
          conclusion: [
            "This new quality productivity is amazing",
            "Safety, energy saving, and efficiency all achieved",
            "Making thermal power plants more efficient, intelligent, and digital",
            "Winning fans with real capabilities!",
          ],
        },
      },
    },
    article53: {
      content: {
        title: "How does a power generation plant cut its carbon emissions?",
        date: "2021-11-24",
        text: [
          "China is to realize carbon neutrality by 2060. Huaneng Group, among China's biggest power generation companies, is one of the key players paving the way to achieving this goal. The smart and green initiative motivates power generation plants like Huaneng's to revolutionize away from traditional smokestack enterprises.",
        ],
        credits: {
          title: "Video Production Team",
          members: [
            "Director & Reporter: Zhou Yiqiu",
            "Cameraman: Guo Yuanheng",
            "Video Editor: Zhou Yiqiu, Wang Zhe",
            "Executive Producer: Wang Mingyan",
            "Chief Editor: Zhang Wan",
          ],
        },
      },
    },
    article57: {
      title: "Beibu Gulf Port's 'Ace Equipment' Shows Impressive Performance",
      date: "2025-04-18",
      preview:
        "Recently, at Berth 2 of Chisha Operation Area in Qisha Port Area of Fangchenggang, the 'ace equipment' of Beibu Gulf Port - the automated bridge-type grab ship unloader has been attracting attention. Despite being a 'steel giant', each cargo grab and release is not only precise and smooth but also rapid and stable. The aluminum ore unloading efficiency reaches 1,626 tons/hour, a 10% improvement over traditional manual operation, making it the first automated bulk cargo ship unloader of its type in China to exceed manual efficiency. The successful operation of the automated bridge-type grab ship unloader is not only an important attempt at the efficient integration of large-scale, automated, and intelligent equipment at Beibu Gulf Port, but also another vivid practice in comprehensively improving service quality and efficiency!",
      content: {
        title: "Beibu Gulf Port's 'Ace Equipment' Shows Impressive Performance",
        date: "2025-04-18",
        text: [
          "Recently, at Berth 2 of Chisha Operation Area in Qisha Port Area of Fangchenggang, the 'ace equipment' of Beibu Gulf Port - the automated bridge-type grab ship unloader has been attracting attention. Despite being a 'steel giant', each cargo grab and release is not only precise and smooth but also rapid and stable. The aluminum ore unloading efficiency reaches 1,626 tons/hour, a 10% improvement over traditional manual operation, making it the first automated bulk cargo ship unloader of its type in China to exceed manual efficiency. The successful operation of the automated bridge-type grab ship unloader is not only an important attempt at the efficient integration of large-scale, automated, and intelligent equipment at Beibu Gulf Port, but also another vivid practice in comprehensively improving service quality and efficiency!",
          "Berths 1-2 of Chisha Operation Area in Qisha Port Area of Fangchenggang are the largest automated dry bulk cargo berths in Guangxi. To meet the modern logistics needs of efficiency, environmental protection, and intelligence, the core business team of Beibu Gulf Port Co., Ltd. and its subsidiary Chisha Terminal led the establishment of a scientific innovation team. After thorough research and demonstration, they initiated the implementation of the fully automated unloading project for dry bulk cargo vessels such as aluminum ore, which was selected for the '2022 Key Science and Technology Projects List' of the Ministry of Transport.",
          "The innovation team focused on the 'project + innovation' construction approach, conducting in-depth research on topics such as 'Research and Application of Automated Technology for Bridge-type Grab Ship Unloaders' and 'Research and Application of Intelligent Dust Suppression Technology for Bridge-type Grab Ship Unloaders'. They successfully developed multiple key technologies including 'Automated Aluminum Ore Unloading Process', 'AI Bionic Operation System for Ship Unloaders', and 'Three-dimensional Space Multi-fusion Technology and Dynamic Perception System'. The 'Automated Aluminum Ore Unloading Process' optimizes the unloading process for aluminum ore characteristics, significantly improving unloading efficiency while saving resources and reducing waste. The 'AI Bionic Operation System' introduces advanced bionic algorithms and intelligent control technology, enabling the unloader to respond intelligently to environmental changes like a living organism, essentially giving it a 'smart brain'. The 'Three-dimensional Space Multi-fusion Technology and Dynamic Perception System' uses precise 3D modeling with millimeter-level positioning to solve complex working conditions, while the multi-modal protection system provides 24/7 safety monitoring, greatly enhancing safety warning capabilities. Additionally, it integrates powerful core equipment such as intelligent dust suppression and monitoring systems, effectively achieving automated and intelligent control, setting a new benchmark for efficient and green loading and unloading technology and equipment. According to calculations, the full implementation of this project will achieve efficiency improvements and revenue generation of approximately 32 million yuan per year.",
          "Berths 1-2 of Chisha Operation Area in Qisha Port Area of Fangchenggang are key projects in building the Western Land-Sea New Corridor and crucial projects in creating the Beibu Gulf International Gateway Port and International Hub Port. They have not only set new records for construction efficiency of similar terminals but also created the fastest record for terminal construction, port opening, and operation in the Guangxi region. Currently, the successful operation of the automated bridge-type grab ship unloader will greatly improve terminal loading and unloading efficiency, effectively reduce vessel berth waiting and departure times, further enhance port turnover rates, and achieve dual reduction in terminal operation costs and customer logistics costs. This will provide efficient and high-quality services for hinterland enterprises such as Guangxi Huasheng, promote the construction of stable supply chain systems for metallurgical, energy, and new materials industries in the port area, and inject new vitality into the high-quality development of the Western Land-Sea New Corridor and the high-level construction of the Beibu Gulf International Gateway Port through the virtuous cycle of 'efficiency-cost-customer base', contributing to the high-quality development of Beibu Gulf Port and the regional economy.",
        ],
        source: "Cosys Technology",
        gallery: [
          {
            url: "/images/news/news57-1.jpg",
            caption:
              "The automated bridge-type grab ship unloader in operation at Beibu Gulf Port",
          },
          {
            url: "/images/news/news57-2.jpg",
            caption: "The intelligent control system of the automated unloader",
          },
        ],
      },
    },
  },
  about: {
    title: "About Cosys",
    profile: {
      title: "Company Profile",
      p1: "Hangzhou Cosys Automation System Co., LTD. (hereinafter referred to as Hangzhou Cosys) is located in Huiding Zhichuang Center, Hangzhou, Zhejiang Province. Its R&D center is situated in Binjiang High-tech Zone, Hangzhou, covering an area of 3,000 square meters. Hangzhou Cosys is a specialized, refined, distinctive and innovative enterprise and a national high-tech enterprise. It also holds the CMMI Level 3 certification for Software Capability Maturity Model Integration, the second-level professional contracting qualification for electronic and intelligent engineering, and the qualification of a municipal-level R&D center.",
      p2: "The company's main products include unmanned systems for bulk material handling industry, intelligent fuel management systems, intelligent operation and maintenance systems, intelligent dispatch systems, comprehensive energy management platforms, and energy storage systems. It has years of experience and application cases in core 3D vision hyper-fusion control technology, image recognition technology, AI Agent, embodied intelligence, and algorithms. Currently, it is a leading enterprise in the intelligent bulk material handling industry.",
      p3: "In 2023, it was selected as one of the 112 provincial industrial digitalization service providers in Zhejiang. The company owns multiple independent intellectual property rights, over 50 national patents and software copyrights, and software testing certifications, making it an advanced industrial intelligent system developer in China.",
      p4: "The company has established long-term technical cooperation relationships with several renowned universities nationwide and has joint R&D centers. Its customers mainly include the five major power groups, local energy groups, national bulk ports, metallurgical industry (sintering process raw material yards), and chemical industry (power centers).",
    },
    culture: {
      title: "Corporate Culture",
      values: {
        title: "Values",
        items: [
          "Customer First",
          "Technical Excellence",
          "Team Spirit",
          "Excellence&Innovation",
          "Perfect Execution",
          "Continuous Evolution",
        ],
      },
      mission: {
        title: "Mission",
        content:
          "Reshaping industrial productivity with innovative AI technology, empowering enterprise digital transformation",
      },
      vision: {
        title: "Vision",
        content:
          "Leading the industrial intelligence revolution, building a future of autonomous machine decision-making",
      },
    },
    history: {
      title: "Development History",
    },
    honors: {
      title: "Honors & Qualifications",
      desc: "In 2023, selected as one of the 112 provincial industrial digitalization service providers in Zhejiang. The company owns multiple independent intellectual property rights, over 50 national patents and software copyrights, and software testing certifications, making it an advanced industrial intelligent system developer in China.",
      items: {
        1: { title: "CMMI3 Certification" },
        2: { title: "Information Security Management System Certification" },
        3: { title: "Quality Management System Certification" },
        4: { title: "Environmental Management System Certification" },
        5: { title: "Zhejiang Specialized and Innovative SME Certificate" },
        6: { title: "National High-tech Enterprise Certificate" },
        7: { title: "Hangzhou Eagle Enterprise Certificate" },
        8: { title: "Hangzhou High-tech Enterprise Certificate" },
        9: {
          title:
            "National Intelligent Power Generation Technology Innovation Achievement Unit",
        },
        10: {
          title: "2023 Provincial Industrial Digitalization Service Provider",
        },
      },
    },
    partners: {
      title: "Partners",
    },
    core: {
      slogan:
        "The integration of AIoT empowers unmanned operation, and the digital engine drives the future of energy",
      stats: [
        { label: "Founded", unit: "Year" },
        { label: "Operational Projects", unit: "+" },
        { label: "Annual Output", unit: "Million" },
        { label: "Cooperative Enterprises", unit: "+" },
      ],
    },
    historyData: [
      {
        year: "2013",
        title: "Company Founded",
        events: [
          "Hangzhou Cosys Automation System Co., Ltd. was officially established",
        ],
      },
      {
        year: "2016",
        title: "Rapid Development",
        events: [
          "Independently completed unmanned operation of 2 bucket wheel machines",
          "Received Hangzhou Eagle Plan Enterprise recognition",
        ],
      },
      {
        year: "2017",
        title: "High-tech Enterprise",
        events: ["Obtained High-tech Enterprise Certificate"],
      },
      {
        year: "2023",
        title: "New Enterprise Journey",
        events: [
          "Received Specialized and Innovative Enterprise recognition",
          "Selected as one of 112 Provincial Industrial Digitalization Service Providers in Zhejiang",
        ],
      },
      {
        year: "2024",
        title: "Technological Innovation",
        events: [
          "Established R&D Center in Binjiang District",
          "Received Silver Award at National Intelligent Power Generation Technology Conference",
        ],
      },
    ],
  },
  solution: {
    title: "Solution & Core Technology",
    subtitle: "SOLUTIONS",
    unmanned: {
      title: "Unattended Solution for Bulk Materials",
      subtitle: "Unattended Solution for Bulk Materials",
      visible: true,
      bucketWheel: {
        title: "Bucket Wheel Machine Unmanned System",
      },
      circularStockyard: {
        title: "Circular Stockyard Intelligent Control System",
      },
      semiGantry: {
        title: "Semi-gantry Scraper Stacker-reclaimer Unmanned System",
      },
      p1: "The bucket wheel machine unmanned system achieves coal pile modeling, material height detection, coal flow detection, anti-collision detection, precise positioning, and visual monitoring through data collection and real-time control. The system can operate autonomously and control multiple bucket wheel machines according to set ratios. Using advanced intelligent control algorithms and real-time data processing technology, it ensures safe, efficient, and stable operation while reducing labor costs.",
      p2: "The circular stockyard intelligent control system utilizes laser scanning and high-precision positioning technology to achieve three-dimensional modeling of material piles, material level detection, anti-collision detection, and precise positioning. The system can operate autonomously and control multiple stacker-reclaimers according to set ratios. Using advanced intelligent control algorithms and real-time data processing technology, it ensures safe, efficient, and stable operation while reducing labor costs.",
      p3: "The semi-gantry scraper stacker-reclaimer unmanned system communicates with the remote coal control room and employs advanced sensor technology to achieve material pile modeling, material level detection, anti-collision detection, precise positioning, and visual monitoring. The system can operate autonomously without human intervention. Using advanced intelligent control algorithms and real-time data processing technology, it ensures safe, efficient, and stable operation while reducing labor costs.",
    },
    fuel: {
      title: "Fuel Intelligence Solutions",
      subtitle: "Fuel Intelligence Solutions",
      visible: true,
      p1: "The intelligent process control system is for the intelligent management and process decision-making of the entire wharf, ore yard, coal yard, auxiliary raw material yard and mixing yard. It mainly includes intelligent dispatching system, intelligent process decision-making system, operation plan management, yard information management, silo information management, performance report management functions, etc. The intelligent process control system uniformly manages hundreds of belts, ship unloaders, stacker-reclaimers, ship loaders, etc. from the entrance to the exit within the wharf. It selects the best process based on information such as equipment attributes, operating costs, and equipment maintenance plans.",
    },
    unloading: {
      title: "AI solution for ship unloaders",
      subtitle: "AI solution for ship unloaders",
      visible: true,
      p1: "The fully automatic control system of the ship unloader, the intelligent anti-shaking system of the ship unloader, and the unmanned vertical model based on deep reasoning for loading and unloading equipment have carried out intelligent transformation of the ship unloader without changing the traditional manual operation mode, achieving fully automatic control of the ship unloader. This system integrates multiple systems such as data acquisition, 3D modeling, equipment control, ship hold management, and production safety into a unified control platform through the method of laser 3D and vision fusion. By combining the 3D laser equipment with high-precision positioning systems, a unified 3D coordinate system for the wharf, ship unloader, and ship hold is established, guiding the ship unloader to precisely take materials from the ship hold, improving work efficiency, reducing the labor intensity of operators, and enhancing the overall operation level of the wharf.",
    },
    inspection: {
      title: "Belt Inspection Solutions",
      subtitle: "Belt Inspection Solutions",
      visible: true,
      p1: "The intelligent inspection system of the belt conveyor forms the operation database of the belt conveyor through data collection in different working states and different time periods. Meanwhile, it continuously collects and trains the AI model to promptly alarm for abnormal situations. It realizes functions such as monitoring the deviation and tearing of the coal conveying belt, alarm for personnel intrusion in the belt area, identification of material spillage on the belt, abnormal alarm for motor vibration and temperature, sound collection, and alarm for excessive concentration of toxic and harmful gases and dust. At the same time, it is equipped with equipment life cycle management, operation and maintenance management, as well as hardware data management to provide support for the healthy operation of the belt system, forming a complete closed-loop system and enhancing the intelligence of the entire coal conveying line.",
    },
    coreTech: {
      title: "Core Technology",
      subtitle: "Core Technology",
      visible: true,
      p1: "Cosys Automation possesses multiple core technologies in the bulk material conveying industry, including 3D vision hyper-fusion control technology, image recognition technology, AI Agent, embodied intelligence, and algorithms. These technologies provide strong technical support for our solutions, ensuring efficient and stable system operation.",
      vision: {
        title: "3D Vision Hyper-fusion Control Technology",
        desc: "Establishes an integrated coordinate system for 3D point cloud data, graphic recognition technology, and production equipment. Through 3D models, it precisely calculates the feature point coordinates of production objects and equipment, integrates visual recognition technology, connects coordinate parameters to the control system, and obtains efficient production control logic through big data analysis to control production equipment in task execution.",
      },
      ai: {
        title: "Intelligent AI Feature Recognition Technology",
        desc: "In industrial environments, obtains on-site video through industrial cameras. Uses computers to process, analyze, and understand on-site images, applies deep learning algorithms to identify various patterns of targets and objects. Recognizes on-site data and achieves digital collection, providing alarm and other indicators.",
      },
      control: {
        title: "Artificial Intelligence Agent",
        desc: "Artificial Intelligence Agent (AI Agent), unlike traditional artificial intelligence, possesses the ability to independently think and use tools to gradually achieve given goals. It is an intelligent entity that perceives the environment, makes decisions, and executes actions. Applied in intelligent systems for bulk material conveying lines.",
      },
    },
  },
  footer: {
    companyNews: "Company News",
    contactInfo: "Contact Information",
    hotline: "Service Hotline",
    workTime: "Working Hours: Monday to Friday 9:00-18:00",
    qrcode: "Scan to Follow Us",
    copyright: "© 2024 Hangzhou Cosys Automation Co., Ltd. All Rights Reserved",
    icp: "浙ICP备13019724号-1",
  },
  contact: {
    title: "Contact Information",
    hotline: "Service Hotline",
    fax: "Fax",
    email: "Email",
    address: "Address",
    addressContent: {
      hq: "9-10 / F, Building 6, Huiding Zhichuang Center, No. 826, Ruquan Road, Binjiang District, Hangzhou City, Zhejiang Province",
    },
  },
  home: {
    vision:
      "The integration of AIoT empowers unmanned operation, and the digital engine drives the future of energy",
    banner: {
      title:
        "Building Digital Energy Smart Hub, Driving Trillion-level Industrial Ecosystem Efficient Collaboration",
      solutions: {
        unmanned: "Unattended Solution for Bulk Materials",
        fuel: "Fuel Intelligence Solutions",
        unloading: "AI solution for ship unloaders",
        inspection: "Belt Inspection Solutions",
        coreTech: "Core Technology",
      },
    },
    stats: {
      founded: { label: "Founded", unit: "Year", value: 2013 },
      base: { label: "Operational project", unit: "+", value: 200 },
      employee: { label: "Annual Output", unit: "Million", value: 20000 },
      partner: { label: "Cooperative enterprise", unit: "+", value: 200 },
    },
    rdStats: {
      title: "Self-developed Core Technologies",
      investment: "Technical Investment Ratio",
      personnel: "R&D Personnel Ratio",
      products: "Self-developed Products Ratio",
      experience: "5+ Years Industry Experience Ratio",
    },
    news: {
      title: "News Center",
      subtitle: "NEWS CENTER",
      more: "Explore More",
      readMore: "Read More",
      list: [
        {
          title:
            'Provincial Honor | ZOCONO Listed in "2024 Guangdong Top 500 Manufacturing Companies"!',
          desc: "On December 3rd, the 2024 Guangdong Top 500 Manufacturing Summit, co-sponsored by the Guangdong Manufacturing Association and the Guangdong Institute of Development and Reform, was held in Guangzhou, where the '2024 Guangdong Top 500 Manufacturing Enterprises Research Report' was released. With its leading technological advantages in industrial automation, ZOCONO, along with renowned enterprises such as BYD, Huawei, Midea, and GAC, was ranked 346th on the '2024 Guangdong Top 500 Manufacturing Companies' list.",
          url: "/news/56",
        },
        {
          title: "5 Billion Project Lands! ZOCONO Wins 2024 Best Support Award",
          desc: "Recently, ZOCONO received good news from CATL's Xiamen project base. In the delivered logistics automation production line project, ZOCONO won multiple honors including the 2024 Best Support Award, Outstanding Project Manager, and Outstanding Individual from CATL, thanks to its rich project experience, leading technical level, and efficient delivery capability.",
          url: "/news/55",
        },
        {
          title: "ZOCONO Wins 2024 Innovation Enterprise Award",
          desc: "ZOCONO continues to innovate and won the 2024 Innovation Enterprise Award, demonstrating the company's technical strength and industry influence in intelligent manufacturing. As the core integrator of CATL's Xiamen lithium battery manufacturing base Phase I high-speed line, ZOCONO has shown excellent technical capabilities and independent R&D capabilities.",
          url: "/news/53",
        },
      ],
    },
  },
};
